import { useEffect, useRef, useState } from 'react';
import { formatPriceWithEuro } from '../../utils/StringUtils';
import Ratingstar from '../Rating_star';
import useAxios from '../../axios/useAxios';
import sliderArrow from '../../styles/img/arrow/sliderArrow.svg';

export const ProductRating = ({ cartItems, user }) => {
  const axiosInstance = useAxios();
  const [invisible, setInvisible] = useState([]);
  const ratingSliderRef = useRef();

  useEffect(() => {
    if (cartItems && cartItems.orderItems.length > 0) {
      console.log(cartItems.orderItems.length);
    }
  }, [cartItems]);
  const ratingAction = async (rating, productId, index) => {
    try {
      const response = await axiosInstance.post('/products/rateProduct', {
        productId: productId,
        rating: rating,
        userId: user._id || null,
        storeId: cartItems.storeId,
        barCode: cartItems.orderItems[index].Code_Barre,
      });
      console.log(index);
      setTimeout(() => {
        setInvisible([...invisible, index]);
      }, 1000);
    } catch (err) {
      console.log(err);

      setTimeout(() => {
        setInvisible([...invisible, index]);
      }, 1000);
    }
  };
  const checkInvisible = (index) => {
    for (let i = 0; i < invisible.length; i++) {
      if (invisible[i] === index) {
        //retirer l'index de cartItems
        return true;
      }
    }
    return false;
  };

  return (
    cartItems &&
    cartItems.orderItems.length != invisible.length && (
      <div className="product-rating-container-of-slider">
        <img
          src={sliderArrow}
          alt="right"
          className="slider-arrow-right"
          onClick={() =>
            ratingSliderRef.current.scrollBy({ left: 200, behavior: 'smooth' })
          }
        />
        <img
          src={sliderArrow}
          alt="left"
          className="slider-arrow-left"
          onClick={() =>
            ratingSliderRef.current.scrollBy({ left: -200, behavior: 'smooth' })
          }
        />
        <div className="product-rating-container" ref={ratingSliderRef}>
          {cartItems.orderItems.map((product, index) => (
            <div
              className={`product-rating ${checkInvisible(index) ? 'product-rate-card-invisible' : ''}`}
              key={index}
            >
              {product.image && (
                <div className="product-rating-image">
                  <img src={product.image} alt="product" />
                </div>
              )}
              <div className="product-rating-title">{product.name}</div>

              <div className="product-rating-content">
                <p>
                  <span>{formatPriceWithEuro(product.price)} </span>
                </p>
              </div>
              <div className="product-rating-stars">
                <Ratingstar
                  starClassName={'w-10 m-2'}
                  action={(rating) => ratingAction(rating, product._id, index)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
};
